import { useAuthData } from '@modules/Auth/hooks/useAuth';
import { useAuthStore } from '@shared/stores/authStore';

// 🎯 Hook para obtener el método de impresión del usuario desde /me
export const usePrintingMethod = () => {
  const { currentUser, isLoadingUser } = useAuthData();
  const settings = useAuthStore((state) => state.settings);

  // 🎯 Extraer printing.method de settings del store (estructura puede ser settings[key]?.value?.value o settings[key]?.value)
  // También verificar si viene directamente en currentUser por compatibilidad
  const printingMethodFromStore = settings?.['printing.method']?.value?.value ?? settings?.['printing.method']?.value;
  const printingMethodFromUser = currentUser?.settings?.['printing.method']?.value;
  const printingMethod = printingMethodFromStore || printingMethodFromUser || 'pdf';
  const isPrintNode = printingMethod === 'printnode';

  // 🎯 Debug logs para identificar el problema
  // console.log('🔍 usePrintingMethod - Debug info:', {
  //   currentUser: currentUser?.id,
  //   settingsFromStore: settings,
  //   settingsFromUser: currentUser?.settings,
  //   printingMethodSetting: settings?.['printing.method'],
  //   extractedMethod: printingMethod,
  //   isPrintNode,
  //   isLoadingUser,
  //   hasCurrentUser: !!currentUser,
  // });

  return {
    printingMethod: printingMethod as 'pdf' | 'printnode',
    isLoading: isLoadingUser,
    isPrintNode,
    hasCurrentUser: !!currentUser, // 🎯 Agregar flag para saber si currentUser está disponible
  };
};
